module.exports = __webpack_public_path__ + "img/mobilenewsLogo3.f2552401.png";